import { createSelector } from '@ngrx/store';
import { State } from './products-page.reducer';
import { selectProductsPageState } from '../index';

export const selectProductsPageTableState = createSelector(selectProductsPageState, (state: State) =>
  state?.tableState?.filters ? state.tableState : undefined
);

export const selectProductsPageUserSettings = createSelector(selectProductsPageState, (state: State) => state.userSettings ?? undefined);
